import { UPDATE_CHART_CONFIG_ITEMS_METADATA } from "./../../../store/chart-config.module/mutations/update-chart-config-items-metadata.mutation";
import { Prop } from "vue-property-decorator";
import { VuexModuleName } from "&/types/vuex/enums/module-name.enum";
import Vue from "vue";
import Component from "vue-class-component";
import { getTemplateChartConfigItemsMetadata } from "../../../services/rxdb-services/get-template-chart-config-items-metadata.service";

/**
 * 图表控件（chart config item）的公共基础类
 * 都会从 ConfigItemsMetadata Map 中读取其配置
 *
 * @export
 * @class ChartConfigItemBaseMixin
 * @extends {Mixins(MetadataObserverMixin)}
 */
@Component
export class ChartConfigItemBaseMixin extends Vue {
  @Prop({ default: false }) readonly shareMode!: boolean;
  @Prop() readonly chartConfigItemMetadatas!: any;

  /**
   * 配置项的名称，也是其作为一个 configItem 的唯一标识
   * 格式为 `[Echarts|Ant|{ChartType}]{Name}ConfigItem`
   * 必须由继承的实例复写
   *
   * @type {string}
   * @memberof ChartConfigItem
   */
  name!: string;

  mounted() {
    // 新增配置项做向下兼容，如果当前是老工作区，会读不到metadata，此时再手动去读一遍模板配置项，并更新metadata
    if (!this.metadata) {
      const selectedTemplateDoc = this.selectedTemplateDoc;
      try {
        getTemplateChartConfigItemsMetadata(selectedTemplateDoc).then(
          (metadataRecords) => {
            this.updateMetadata(this.name, metadataRecords[this.name]);
          },
        );
      } catch (err) {
        console.log(err);
      }
    }
  }

  /**
   * 从工作区配置读取的 config item 配置 map
   *
   * @readonly
   * @memberof ChartConfigItem
   */
  get configItemsFromWorkspace() {
    if (this.shareMode) return this.chartConfigItemMetadatas;
    return this.$stock.state[VuexModuleName.CHART_CONFIG].metadataRecords;
  }

  get metadata(): ChartConfigItemMetadata {
    return this.configItemsFromWorkspace[this.name];
  }

  public updateMetadata(path: string, value: any) {
    if (this.shareMode) return;
    this.$stock.commit(UPDATE_CHART_CONFIG_ITEMS_METADATA, {
      path,
      value,
    });
  }
}
